<template>
  <b-modal
    id="new"
    no-close-on-backdrop
    hide-footer
    modal-class="modern-modal"
    @show="evOnShow"
    @hide="evOnHide"
  >
    <template v-slot:modal-title>
      <div class="modal-title-modern">
        <i class="fas fa-user mr-2"></i>
        Adicionar usuário
      </div>
    </template>

    <div class="modal-content-modern">
      <b-form @submit.prevent="evOnSubmit">
        <div class="form-grid">
          <div class="form-group full-width">
            <LabelRequiredField label="Usuário" />
            <select v-model="user_id" class="modern-form-input">
              <option value="">SELECIONE...</option>
              <option v-for="(user, key) in users" :key="key" :value="user.id">
                {{ String(user.name).toUpperCase() }}
              </option>
            </select>
          </div>

          <div class="form-group full-width">
            <label class="form-label">Observação</label>
            <input v-model="note" type="text" class="modern-form-input" />
          </div>
        </div>

        <div class="form-footer">
          <warning-required-fields />
          <errors-messages :errors="errors" />

          <div class="form-actions">
            <v-btn
              :disabled="loading"
              class="btn-cancel-modern"
              @click="$bvModal.hide('new')"
            >
              <i class="fas fa-times mr-2"></i>
              Cancelar
            </v-btn>
            <v-btn :disabled="loading" type="submit" class="btn-save-modern">
              <i class="fas fa-save mr-2"></i>
              {{ loading ? "Salvando..." : "Salvar" }}
            </v-btn>
          </div>
        </div>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import toast from "../../lib/ToastNotification";
import api from "../../services/api";
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import LabelRequiredField from "../Components/LabelRequiredField.vue";
import WarningRequiredFields from "../Components/WarningRequiredFields.vue";

export default {
  name: "NewTypeAlertStockLot",

  components: {
    LabelRequiredField,
    WarningRequiredFields,
    ErrorsMessages,
  },

  data() {
    return {
      errors: [],

      loading: false,

      user_id: "",
      note: "",
    };
  },

  props: {
    users: Array,
  },

  methods: {
    async evOnShow() {
      this.errors = [];
      this.loading = false;
      this.user_id = "";
      this.note = "";
    },

    async evOnHide() {},

    async evOnSubmit() {
      try {
        this.loading = true;

        this.errors = [];

        let { user_id, note } = this;

        const data = {
          user_id,
          note,
        };

        const response = await api.post(
          "/rest-home/type-alert-stock-lot",
          data
        );

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.$bvModal.hide("new");
          toast(message, "success");
          this.$emit("created");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.modal-content-modern {
  padding: 8px 0;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.modern-form-input {
  border: 2px solid #e5e7eb !important;
  border-radius: 8px !important;
  padding: 12px 16px !important;
  font-size: 14px !important;
  transition: all 0.3s ease !important;
  background: white !important;
}

.modern-form-input:focus {
  border-color: #0f65b0 !important;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1) !important;
  outline: none !important;
}

.form-footer {
  border-top: 1px solid #e5e7eb;
  padding-top: 24px;
  margin-top: 24px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
}

.btn-cancel-modern {
  background: white !important;
  color: #64748b !important;
  border: 2px solid #e5e7eb !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease !important;
}

.btn-cancel-modern:hover {
  background: #f8fafc !important;
  border-color: #cbd5e1 !important;
}

.btn-save-modern {
  background: linear-gradient(135deg, #1e884d 0%, #16a34a 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(30, 136, 77, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-save-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(30, 136, 77, 0.4) !important;
}

.btn-save-modern:disabled,
.btn-cancel-modern:disabled {
  opacity: 0.7 !important;
  cursor: not-allowed !important;
  transform: none !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .form-actions {
    flex-direction: column;
    gap: 8px;
  }

  .btn-cancel-modern,
  .btn-save-modern {
    width: 100%;
  }
}
</style>